export default {
    PAGE: {
        VERMARKTUNGSRECHTE: {
            ERZEUGERAUSWAHL: '/vermarktungsrechte/erzeugerauswahl',
            ERZEUGERKONTEN: '/vermarktungsrechte/erzeugerkonten/:erzeuger_nr',
            WIZARD: '/ghe-meldung/online-abgabe/:konto_key',
            GHE_MELDUNG_EZZ: '/ghe-meldung/:konto_key/erzeuger/:erzeuger_nr/:back_to?',
            GHE_MELDUNG: '/ghe-meldung/:konto_key/:back_to?',
            UEBERSICHT: '/vermarktungsrechte',
            EWMDETAIL_EZZ: '/ewmdetail/:konto_key/erzeuger/:erzeuger_nr/:back_to?',
            EWMDETAIL: '/ewmdetail/:konto_key/:back_to?',
            DWDETAIL_EZZ: '/dwdetail/:konto_key/erzeuger/:erzeuger_nr/:back_to?',
            DWDETAIL: '/dwdetail/:konto_key/:back_to?',
            GHE_MELDUNG_TA_CONFIRM: '/ta-confirm/:konto_key/:back_to?',
        },
    },
    API: {
        VERMARKTUNGSRECHTE: {
            ERZEUGERAUSWAHL: '/betrieb/:betrieb_nr/vermarktungsrecht/erzeuger',
            ERZEUGERKONTEN: '/betrieb/:betrieb_nr/vermarktungsrecht/erzeuger-konten\\?filter[erzeuger_nr]=:erzeuger_nr',
        },
        VERMARKTUNGSRECHT_BETRIEB: '/betrieb/:betrieb_nr/vermarktungsrecht/betrieb\\?expand=gheVom',
        BETRIEB: '/betriebe/:betrieb_nr',
        STAND: '/vermarktungsrecht/stand',
        VERMARKTUNGSRECHT_KONTOKEY: '/betrieb/:betrieb_nr/vermarktungsrecht/betrieb/:konto_key\\?expand=gheMeldung,gheVom',
        GHE_TAN_GENERATE: '/vermarktungsrecht-online-abgabe/:konto_key/tan/generate',
        GHE_TAN_RESEND: '/vermarktungsrecht-online-abgabe/:konto_key/tan/resend',
        GHE_TAN_VALIDATE: '/vermarktungsrecht-online-abgabe/:konto_key/tan/validate/:tanToValidate',
        GHE_MELDUNG_PDF: '/vermarktungsrecht/download/pdf/:konto_key',
        VERMARKTUNGSRECHT_EXCEL: '/betrieb/:betrieb_nr/vermarktungsrecht/betrieb/excel-export',
        VERMARKTUNGSRECHT_EZZ_EXCEL: '/betrieb/:betrieb_nr/vermarktungsrecht/erzeuger-konten/excel-export/:erzeuger_nr?',
    },
    DOCUMENTS: {
        DATENSATZBESCHREIBUNG_EXCEL: '/documents/Datensatzbeschreibung_Export_VM_Excel.xls',
        ERLAEUTERUNG: '/documents/Erlaeuterungen_Vermarktungsrechte.pdf',
    },
    EXPORT: {
        EXCEL: '/weinbaukartei/VermarktungsrechteExcel/bnr/:betrieb_nr',
    },
};
